import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import HowItWorksImg from "./../Images/how-it-works.png";
import { FaChevronRight } from "react-icons/fa";
// import Client from '../Home/Client/Client';


const OrderConfirmed = () => {
    const [file, setFile] = useState();
    function handleChange(e) {
        console.log(e.target.files);
        setFile(URL.createObjectURL(e.target.files[0]));
        setFile(URL.createObjectURL(e.target.files[0].name));
        // selectedFileName: event.target.files[0].name
    }
    return (
        <>
            <Header />

         
            <div className='pt-5'>
                {/* Contact-us */}

                <section className="contact py-5 mt-5 bg-light">
                    <div className="container">
                        <div className='row'>
                            <div className='col-lg-3'></div>
                            <div className='col-lg-6'>
                                <div className="contact-form padd-60 shadow text-center bg-white">
                                    <span className="check">
                                        <i className="fa-solid fa-check"></i>
                                    </span>
                                    <div className="input-title mt-4 mb-4">
                                        <h3 className='mb-4'>Thanks for Your Order</h3>
                                        <p className='mb-4'>Create an Account with ACOUNTIER so our Team can know
                                            about yourself before Connecting with you</p>
                                    </div>
                                    <div className='Bck-btn'>
                                        <Link to="/">Back Home</Link>
                                    </div>
                                </div>
                                <div className='col-lg-3'></div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default OrderConfirmed;